var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      pad: "0",
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_BlockLeavePolicy_form_editTitle")
        : _vm.$t("label_essweb_BlockLeavePolicy_form_viewTitle"),
      delBtn: _vm.hasBtn("delete-admin-block-leave-policy-group"),
      initData: _vm.BlockLeaveGroupData,
      checkData: [
        "block_leave_group_name",
        "block_leave_group_code",
        "include_holiday",
        "start_month",
        "min_days",
        "include_day_off",
        "remarks",
      ],
      editBtn:
        !_vm.iSEdited && _vm.hasBtn("edit-admin-block-leave-policy-group"),
    },
    on: {
      cancel: _vm.toBack,
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_BlockLeavePolicy_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: { curTab: _vm.curTab, items: _vm.taber },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "white lighten-5",
                              attrs: { align: "center", justify: "start" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "100",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      bindData:
                                        _vm.BlockLeaveGroupData
                                          .block_leave_group_name,
                                      label: _vm.$t(
                                        "label_essweb_BlockLeavePolicy_list_BlockLeaveGroupNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.BlockLeaveGroupData.block_leave_group_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      label: _vm.$t(
                                        "label_essweb_BlockLeavePolicy_form_BlockLeaveGroupCodeLabel"
                                      ),
                                      maxlength: "100",
                                    },
                                    model: {
                                      value:
                                        _vm.BlockLeaveGroupData
                                          .block_leave_group_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.BlockLeaveGroupData,
                                          "block_leave_group_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "BlockLeaveGroupData.block_leave_group_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("numberInputTextFiled", {
                                    attrs: {
                                      disabled: "",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 99]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_BlockLeavePolicy_form_BlockLeaveStartMonthLabel"
                                      ),
                                      max: 12,
                                      min: 1,
                                      isNotRequire: "",
                                    },
                                    model: {
                                      value:
                                        _vm.BlockLeaveGroupData.start_month,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.BlockLeaveGroupData,
                                          "start_month",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "BlockLeaveGroupData.start_month",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("numberInputTextFiled", {
                                    attrs: {
                                      disabled: "",
                                      filled: _vm.iSEdited,
                                      readonly: !_vm.iSEdited,
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 99]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_BlockLeavePolicy_form_BlockLeaveMinDaysLabel"
                                      ),
                                      isNotRequire: "",
                                    },
                                    model: {
                                      value: _vm.BlockLeaveGroupData.min_days,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.BlockLeaveGroupData,
                                          "min_days",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "BlockLeaveGroupData.min_days",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("BooleanRadioField", {
                                    attrs: {
                                      disabled: !_vm.iSEdited,
                                      isRequire: "",
                                      label: _vm.$t(
                                        "label_essweb_BlockLeavePolicy_form_includeHolidayLabel"
                                      ),
                                    },
                                    on: {
                                      click: function (boolean) {
                                        _vm.BlockLeaveGroupData.include_holiday =
                                          boolean
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.BlockLeaveGroupData.include_holiday,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.BlockLeaveGroupData,
                                          "include_holiday",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "BlockLeaveGroupData.include_holiday",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("BooleanRadioField", {
                                    attrs: {
                                      disabled: !_vm.iSEdited,
                                      isRequire: "",
                                      label: _vm.$t(
                                        "label_essweb_BlockLeavePolicy_form_includeDayOffLabel"
                                      ),
                                    },
                                    on: {
                                      click: function (boolean) {
                                        _vm.BlockLeaveGroupData.include_day_off =
                                          boolean
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.BlockLeaveGroupData.include_day_off,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.BlockLeaveGroupData,
                                          "include_day_off",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "BlockLeaveGroupData.include_day_off",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _vm.iSEdited
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "text-capitalize",
                              attrs: { text: "", small: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.newLeveType()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("label_essweb_leaveType_list_title")
                                  ) +
                                  " "
                              ),
                              _c(
                                "span",
                                { staticClass: "material-icons-round" },
                                [_vm._v("add")]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.LeaveType.length <= 0 ? _c("noContent") : _vm._e(),
                      _c(
                        "v-container",
                        { staticClass: "ma-0 pa-0 px-3", attrs: { fluid: "" } },
                        [
                          _c(
                            "v-form",
                            { ref: "form2", attrs: { "lazy-validation": "" } },
                            _vm._l(_vm.LeaveType, function (item, index) {
                              return _c(
                                "v-sheet",
                                {
                                  key: "leavetype--" + index,
                                  staticClass: "d-flex align-center my-3",
                                },
                                [
                                  _c("AutoComplete", {
                                    staticClass: "flex-grow-1",
                                    attrs: {
                                      isRequired: "",
                                      "two-line": "",
                                      filled: true,
                                      readonly: true,
                                      items: _vm.LeaveTypeList,
                                      "item-text": "leave_type_name",
                                      label:
                                        "label_essweb_leaveType_list_title",
                                      "item-value": "uuid",
                                      rules: _vm.$GetRules(
                                        ["_Require_ArrRules"],
                                        [null]
                                      ),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function (ref) {
                                            var data = ref.data
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item.leave_type_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--secondary text-caption",
                                                },
                                                [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          data.item
                                                            .leave_type_abbr
                                                        )
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.title",
                                          fn: function (ref) {
                                            var data = ref.data
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item.leave_type_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "item.subtitle",
                                          fn: function (ref) {
                                            var data = ref.data
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item.leave_type_abbr
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: item.uuid,
                                      callback: function ($$v) {
                                        _vm.$set(item, "uuid", $$v)
                                      },
                                      expression: "item.uuid",
                                    },
                                  }),
                                  _vm.iSEdited
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "text-capitalize ml-1",
                                          attrs: {
                                            icon: "",
                                            color: "secondary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteLeveType(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "material-icons-round",
                                            },
                                            [_vm._v("delete")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: _vm.curTab == "tab-1" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newMapping", {
              ref: "newMapping",
              on: { change: _vm.getMappingList },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }